import Courseware from './index.vue';

export default [
  {
    path: '/courseware',
    name: 'Courseware3',
    component: Courseware,
    meta: {
      title: '云盘资源管理',
    },
  },
];



// WEBPACK FOOTER //
// ./src/views/Courseware/index.js